<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs4>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs8>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y v-if="user.role.roleName != 'FINANCE_MANAGER'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="exportAllPO()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromIssueDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="queryParams.fromIssueDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toIssueDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="queryParams.toIssueDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="Order Year"
                label="Order Year"
                type="text"
                v-model="queryParams.orderYear"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="Procurement Plan No"
                label="Procurement Plan No"
                type="text"
                v-model="queryParams.procurementPlanNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="purchaseOrderStatusList"
                label="Choose Status ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex
              sm4
              v-if="
                user.roleName == 'ADMIN' ||
                  (user.role.roleName == 'PROCUREMENT_MANAGER' &&
                    !user.warehouseId)
              "
            >
              <v-autocomplete
                :items="warehouseList"
                :hide-no-data="true"
                color="blue-grey lighten-2"
                label="Choose Warehouse..."
                item-value="id"
                item-text="name"
                menu-props="auto"
                v-model="queryParams.warehouseId"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="purchaseTypeList"
                label="Choose Purchase Type..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.purchaseType"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="description"
                label="Description"
                type="text"
                v-model="queryParams.description"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="purchaseOrderList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.issueDateInMilliSeconds | formatMsDate }}</td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.orderYear }}</td>
              <td>{{ props.item.warehouseName }}</td>
              <td>{{ props.item.procurementPlanNo }}</td>
              <td>{{ props.item.purchaseType }}</td>
              <td>{{ props.item.totalUnitCost | decFormat(6) }}</td>
              <td>{{ props.item.creditPaidAmount | decFormat(6) }}</td>
              <td>
                {{ props.item.estArrivalDateInMilliSeconds | formatMsDate }}
              </td>
              <td>{{ props.item.description }}</td>
              <td>
                {{ props.item.updatedDateInMilliSeconds | formatMsDateTime }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
              <!-- <td>
                <v-btn
                  color="primary"
                  @click.stop="printPOInvoice(props.item.id)"
                  >PRINT</v-btn
                >
              </td> -->
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <purchaseOrderExcel
      :isOpen="openDialog"
      v-on:change="dialogClose()"
    ></purchaseOrderExcel>
  </v-container>
</template>

<script>
import { purchaseOrderService } from "../../services/purchase-order-service";
import { warehouseService } from "../../services/warehouse-service";
import { commonService } from "../../services/common-service";
import purchaseOrderExcel from "../../components/purchase-order/PurchaseOrderExcel";

export default {
  name: "PurchaseOrderList",

  components: { purchaseOrderExcel },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    openDialog: false,
    buttonLoading: false,
    showFilters: false,
    issueDate: commonService.formatDate(
      new Date().toISOString().substr(0, 10),
      "YYYY-MM-DD"
    ),
    showListLoading: false,
    breadcrumbs: [
      {
        text: "Asset Management",
        disabled: true,
      },
      {
        text: "Purchase Order(Asset)",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", value: "action", sortable: false },
      { text: "Status", value: "status" },
      { text: "Issue Date", align: "left", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "Order Year", value: "orderYear" },
      { text: "Warehouse", value: "warehouse.name" },
      { text: "Procurement No", value: "Procurement No" },
      { text: "Purchase Type", value: "purchaseType" },
      { text: "Total Net Cost", value: "totalAmount", sortable: false },
      { text: "Credit Paid Amount", sortable: false },
      { text: "Est. Arrival Date", value: "estArrivalDate" },
      { text: "Description", value: "description" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
      // { text: "Print", sortable: false },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    purchaseOrderStatusList: [
      { label: "----All----", value: "" },
      { label: "တင်ပြရန်ကျန်", value: "တင်ပြရန်ကျန်" },
      { label: "ခွင့်ပြုချက်စောင့်", value: "ခွင့်ပြုချက်စောင့်" },
      { label: "တင်ဒါခေါ်ယူထားရှိမှု", value: "တင်ဒါခေါ်ယူထားရှိမှု" },
      { label: "တင်ဒါစိစစ်ပြီးစီးမှု", value: "တင်ဒါစိစစ်ပြီးစီးမှု" },
      { label: "စာချုပ်ပြီးပစ္စည်းစောင့်", value: "စာချုပ်ပြီးပစ္စည်းစောင့်" },
      {
        label: "ခွင့်ပြုချက်ရပြီးပစ္စည်းစောင့်",
        value: "ခွင့်ပြုချက်ရပြီးပစ္စည်းစောင့်",
      },
      { label: "စာချုပ်ပြီးလုပ်ငန်းစတင်", value: "စာချုပ်ပြီးလုပ်ငန်းစတင်" },
      { label: "PROGRESS_PERCENT", value: "PROGRESS_PERCENT" },
      { label: "ဖွင့်ဖောက်", value: "ဖွင့်ဖောက်" },
      { label: "FAC", value: "FAC" },
      { label: "ကုန်ပစ္စည်းရောက်ရှိမှု", value: "ကုန်ပစ္စည်းရောက်ရှိမှု" },
      { label: "ဝယ်ယူပြီးစီးမှု", value: "ဝယ်ယူပြီးစီးမှု" },
    ],
    purchaseOrderList: [],
    warehouseList: [],
    totalRows: 0,
    totalAmount: 0,
    allTotalQty: 0,
    allPurchaseOrderList: [],
    reportedDate: commonService.formatDate(new Date(), "DD/MM/YYYY"),
    queryParams: {
      fromIssueDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toIssueDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      status: "",
      warehouseId: "",
      description: "",
      updateUserId: "",
      purchaseType: "",
      purchaseOrderType: "ASSET",
    },
    purchaseTypeList: [{ label: "---All---", value: "" }],
  }),
  watch: {
    pagination: {
      handler() {
        this.getPurchaseOrderList();
      },
      deep: true,
    },
  },
  created() {
    //for deep linking
    if (
      this.user.roleName == "WAREHOUSE_MANAGER" ||
      this.user.role.roleName == "WAREHOUSE_STAFF" ||
      this.user.roleName == "BRANCH_ADMIN"
    ) {
      this.queryParams.warehouseId = this.user.warehouse.id;
    }
    if (this.user.roleName == "SALE_MANAGER") {
      this.queryParams.updateUserId = this.user.id;
    }
    if (this.user.roleName == "PROCUREMENT_MANAGER") {
      this.queryParams.warehouseId = this.user.warehouseId;
    }
    if (this.user.roleName == "ASSET_MANAGER") {
      this.queryParams.warehouseId = this.user.shop.warehouseId;
    }
    if (this.$route.query.fromIssueDate) {
      this.queryParams.fromIssueDate = this.$route.query.fromIssueDate;
    }
    if (this.$route.query.toIssueDate) {
      this.queryParams.toIssueDate = this.$route.query.toIssueDate;
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.warehouseId) {
      this.queryParams.warehouseId = Number(this.$route.query.warehouseId);
    }
    if (this.$route.query.updateUserId) {
      this.queryParams.updateUserId = Number(this.$route.query.updateUserId);
    }
    if (this.$route.query.purchaseOrderType) {
      this.queryParams.purchaseOrderType = this.$route.query.purchaseOrderType;
    }
    if (this.$route.query.orderYear) {
      this.queryParams.orderYear = this.$route.query.orderYear;
    }
    if (this.$route.query.procurementPlanNo) {
      this.queryParams.procurementPlanNo = this.$route.query.procurementPlanNo;
    }
    if (this.$route.query.description) {
      this.queryParams.description = this.$route.query.description;
    }
    if (this.$route.query.purchaseType) {
      this.queryParams.purchaseType = this.$route.query.purchaseType;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.rowsPerPage) {
      this.pagination.rowsPerPage = this.$route.query.rowsPerPage;
    }
    if (this.$route.query.description) {
      this.pagination.description = this.$route.query.description;
    }
    this.getWarehouseList();
    this.getAllPurchaseType();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.rowsPerPage = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "purchase-order-assets",
        query: this.queryParams,
      });
      this.getPurchaseOrderList();
    },
    dialogClose() {
      this.openDialog = false;
      this.getPurchaseOrderList();
    },
    getPurchaseOrderList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      purchaseOrderService
        .getPurchaseOrderList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.purchaseOrderList = res.data.data;
            this.totalRows = res.data.totalElements;
            this.totalAmount = res.data.totalAmount;
            this.allTotalQty = res.data.allTotalQty;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
          let findAll = {
            id: "",
            name: "----All----",
          };
          this.warehouseList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onRegister() {
      this.$router.push("/purchase-order-asset/new");
    },
    onRegisterOrder() {
      this.$router.push("/po-order");
    },
    onEdit(data) {
      this.$router.push("/purchase-order-asset/" + data.id);
    },
    printPOInvoice(id) {
      purchaseOrderService.printPOInvoice(id).then((res) => {
        var blob = res;
        purchaseOrderService.showWindowDialog(blob, "invoice-" + id);
      });
    },
    exportAllPO() {
      this.buttonLoading = true;
      purchaseOrderService
        .exportPurchaseOrderExcel(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
    getAllPurchaseType() {
      purchaseOrderService.getAllPurchaseTypes("ASSET").then((res) => {
        let tempList = res.data;
        tempList.forEach((item) => {
          let tempObj = { label: item, value: item };
          this.purchaseTypeList.push(tempObj);
        });
      });
    },
  },
};
</script>
